export default __webpack_public_path__ + "static/media/ico_world.37b27a29.svg";